// extracted by mini-css-extract-plugin
module.exports = {"feed":"PhotoFeed_feed__2C_nO"};